jQuery(function ($) {
  footer_accordian();
  menuTab();
  mobileMenu();
  setTimeout(function () {
    footer_certification_slider();
  }, 200);

  source_of_lead_addition();
  popupForm();
});

// footer certification slider js
function footer_certification_slider() {
  jQuery(".footer-certification-slider  .common-logo-slider").owlCarousel({
    items: 2,
    loop: false,
    margin: 0,
    nav: true,
    dots: false,
    autoplay: false,
    smartSpeed: 2200,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      768: {
        items: 4,
      },
      1024: {
        items: 5,
        loop: true,
        autoplay: true,
      },
      1200: {
        items: 6,
      },
      1340: {
        items: 7,
        // mouseDrag: false,
        // touchDrag: false,
        // loop: false,
        nav: false,
      },
    },
  });
}

// footer accordian js start here for desktop and mobile
function footer_accordian() {
  if (window.matchMedia("(max-width: 767px)").matches) {
    // footer accordian
    jQuery(".footer-block:first-child .footer-title").addClass("open");
    jQuery(
      ".footer-block:first-child .menu-footer-services-menu-container"
    ).slideDown();
    jQuery(".footer-block:not(:first-of-type) .content_widget").css(
      "display",
      "none"
    );
    jQuery(".footer-block:not(:first-of-type) .widgets_wrap").css(
      "display",
      "none"
    );

    jQuery(".footer-block .footer-title").click(function () {
      jQuery(".open").not(this).removeClass("open").next().slideUp(700);
      jQuery(this).toggleClass("open").next().slideToggle(700);
    });

    // footer-contact accordian start
    jQuery(".contact-block:first-child .accordian-top ").addClass("show");
    jQuery(" .contact-block:not(:first-of-type) .accordian-bottom ").css(
      "display",
      "none"
    );
    jQuery(" .contact-block .accordian-top").click(function () {
      jQuery(".show").not(this).removeClass("show").next().slideUp(700);
      jQuery(this).toggleClass("show").next().slideToggle(700);
    });
  }
}

// header js start here
function menuTab() {
  jQuery(".navabar li").each(function () {
    jQuery(this).find(".menu-tab  .menu-tab-item").first().addClass("active");
    jQuery(this)
      .find(".menu-list-content .menu-list-data")
      .first()
      .addClass("active");

    jQuery(".menu-tab  .menu-tab-item").click(function () {
      var tabID = jQuery(this).attr("data-tab");
      jQuery(this).addClass("active").siblings().removeClass("active");
      jQuery("#data-" + tabID)
        .parent()
        .addClass("active")
        .siblings()
        .removeClass("active");
    });
  });
}

function mobileMenu() {
  if (window.matchMedia("(max-width:1119px)").matches) {
    jQuery(function () {
      jQuery(".menu-title .menu-item").click(function () {
        jQuery(".open").not(this).removeClass("open").next().slideUp(500);
        jQuery(this).toggleClass("open").next().slideToggle(500);
      });
    });
    jQuery(function () {
      jQuery("#mobile-menu").click(function () {
        jQuery(".biztech-header").toggleClass("active");
        jQuery("body").toggleClass("hidden_navigation");
      });
    });
    jQuery(function () {
      jQuery(".menu-list-data").removeClass("active");
      jQuery(".menu-list-content .menu-tab-item").click(function () {
        var tabID = jQuery(this).attr("data-tab");
        var targetTab = jQuery("#data-" + tabID);

        if (targetTab.parent().hasClass("active")) {
          targetTab.parent().removeClass("active").find(".menu-list").slideUp();
        } else {
          targetTab
            .parent()
            .addClass("active")
            .siblings()
            .removeClass("active")
            .find(".menu-list")
            .slideUp();
          targetTab.parent().find(".menu-list").slideDown();
        }
      });
    });
  }
}

function source_of_lead_addition() {
  if (document.readyState !== "loading") {
    if (
      window.localStorage.getItem("source_of_lead") == "" ||
      window.localStorage.getItem("source_of_lead") == undefined
    ) {
      let source_of_lead = "";
      if (document.referrer == "" || document.referrer == undefined) {
        source_of_lead = window.location.href;
      } else {
        source_of_lead = document.referrer;
      }
      window.localStorage.setItem("source_of_lead", source_of_lead);
    }
    this.customeJourney = window.localStorage.getItem("customeJourney");
    let date = new Date();
    this.customeJourney =
      this.customeJourney == null || this.customeJourney == ""
        ? []
        : JSON.parse(this.customeJourney);
    let diff = null;
    let className = "";
    setTimeout(() => {
      jQuery(document).click(function (event) {
        //commented on 01-02-2023 because of clickedclass content issue.
        // if (event.target && event.target.innerText && event.target.innerText != "") {
        //     localStorage.setItem('clickedClass', event.target.innerText);
        // } else {
        className = jQuery(event.target).attr("class");
        if (className == undefined) {
          className = "";
        }
        localStorage.setItem("clickedClass", className);
        // }
      });
    }, 1000);
    setTimeout(() => {
      if (this.customeJourney && this.customeJourney.length) {
        let prevDate =
          this.customeJourney[this.customeJourney.length - 1]["visited_at"];
        let diff = Math.abs(date - new Date(prevDate));
        this.customeJourney[this.customeJourney.length - 1]["spendtime"] =
          Math.floor(diff / 1000);
        diff = null;
      }
      let referrerURL = "";
      if (document.referrer == "" || document.referrer == undefined) {
        referrerURL = window.location.href;
      } else {
        referrerURL = document.referrer;
      }
      this.customeJourney.push({
        refreelUrl: referrerURL,
        currentURL: window.location.href,
        buttonclick: localStorage.getItem("clickedClass"),
        spendtime: diff,
        visited_at: date,
      });
      localStorage.setItem(
        "customeJourney",
        JSON.stringify(this.customeJourney)
      );
      localStorage.removeItem("clickedClass");
      className = null;
    }, 700);
  }
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function popupForm() {
  var popuplenonready = jQuery("body #success_btn_popup").length;

  //popup after 45 seconds of inactivity on ready.
  // if (popuplenonready > 0 && getCookie("popupstatus") != "shown") {
  //   setTimeout(function () {
  //     if (getCookie("popupstatus") != "shown") {
  //       biz_popup();
  //       document.cookie = "popupstatus=shown; expires=0; path=/";
  //     }
  //   }, 15000);
  // }

  //popup on exit intent
  // if (popuplenonready > 0) {
  //   function addEvent(obj, evt, fn) {
  //     if (obj.addEventListener) {
  //       obj.addEventListener(evt, fn, false);
  //     } else if (obj.attachEvent) {
  //       obj.attachEvent("on" + evt, fn);
  //     }
  //   }

  //   addEvent(document, "mouseout", function (evt) {
  //     if (evt.toElement == null && evt.relatedTarget == null) {
  //       if (getCookie("popupstatus") != "shown") {
  //         biz_popup();
  //         document.cookie = "popupstatus=shown; expires=0; path=/";
  //       }
  //     }
  //   });
  // }

  //popup on exit intent
  // if (popuplenonready > 0) {

  // addEvent(document, "mouseout", function (evt) {
  //   console.log("Hello");

  //   if (evt.toElement == null && evt.relatedTarget == null) {
  //     console.log("Hello");
  //     // if (getCookie("popupstatus") != "shown") {
  //     // biz_popup();
  //     // document.cookie = "popupstatus=shown; expires=0; path=/";
  //     // }
  //   }
  // });
  // }
  // window.addEventListener("focus", function () {
  //   console.log("Focused In");
  // });
  // window.addEventListener("blur", function () {
  //   console.log("Focused Out");
  // });

  // window.addEventListener("beforeunload", function (e) {
  //   e.preventDefault();
  //   e.returnValue = "";
  // });

  if (popuplenonready > 0) {
    document.addEventListener("mousemove", function (e) {
      if (e.clientY < 50 && getCookie("exitIntentShown") !== "true") {
        setCookie("exitIntentShown", "true", 0);

        jQuery.fancybox({
          wrapCSS: "success_popup_wrap new_popup",
          href: "#success_btn_popup",
        });
      }
    });

    // window.addEventListener("beforeunload", function (e) {
    //   jQuery.fancybox({
    //     wrapCSS: "success_popup_wrap new_popup",
    //     href: "#success_btn_popup",
    //   });

    //   e.preventDefault();
    //   e.returnValue = "";
    // });
  }
}



// WEBPACK FOOTER //
// ./scripts/layout/script.js